export const RECORDING_MODES = {
  SPIROMETRY: "spirometry",
  TIDAL: "tidal-breathing",
  PULSE: "pulse-scan",
  POSTEXERTION: "post-exertion",
  SIX_MINUTE_WALK: "six-minute-walk",
  MAUDIO: "manual-audio",
};

export const DEFAULT_RECORDING_MODES = [
  RECORDING_MODES.SPIROMETRY,
  RECORDING_MODES.TIDAL,
];

export const ALL_MODES = Object.values(RECORDING_MODES);
